// extracted by mini-css-extract-plugin
module.exports = {"input":"styles_input__Q2fBM","label":"styles_label__rTs7f"};